<template>
  <footer class="footer" id="contact">

      <div class="checkered-pattern"></div>
      <div class="footer-content">
        <div class="footer-logo">
          <span class="ff-t4">Mia</span>
        </div>
        <div class="flex-row d-flex justify-content-center align-items-center mb-4">

          <div class="social-border"></div>
          <div style="margin-bottom: 16px;" class="mx-2 flex-row d-flex justify-content-center align-items-center">

            <div class="mx-2 cursor-pointer" @click="openInstagram">
              <svg width="42px" height="42px" viewBox="0 -0.5 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="24" height="24" fill="#ea3531" />

                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M15.5 5H9.5C7.29086 5 5.5 6.79086 5.5 9V15C5.5 17.2091 7.29086 19 9.5 19H15.5C17.7091 19 19.5 17.2091 19.5 15V9C19.5 6.79086 17.7091 5 15.5 5Z"
                  stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M12.5 15C10.8431 15 9.5 13.6569 9.5 12C9.5 10.3431 10.8431 9 12.5 9C14.1569 9 15.5 10.3431 15.5 12C15.5 12.7956 15.1839 13.5587 14.6213 14.1213C14.0587 14.6839 13.2956 15 12.5 15Z"
                  stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <rect x="15.5" y="9" width="2" height="2" rx="1" transform="rotate(-90 15.5 9)" fill="#ffffff" />
                <rect x="16" y="8.5" width="1" height="1" rx="0.5" transform="rotate(-90 16 8.5)" stroke="#ffffff"
                  stroke-linecap="round" />
              </svg>
            </div>
            <div class="mx-2 cursor-pointer " @click="openTripAdvisor">
              <svg width="40px" height="40px" viewBox="0 0 512.2 512.2" id="Layer_2" xmlns="http://www.w3.org/2000/svg">
                <rect width="512.2" height="512.2" fill="#ea3531" />
                <g transform="translate(25.61, 121.61) scale(0.9)">
                  <path fill="#FFFFFF"
                    d="M128.2 127.9C92.7 127.9 64 156.6 64 192c0 35.4 28.7 64.1 64.1 64.1 35.4 0 64.1-28.7 64.1-64.1.1-35.4-28.6-64.1-64-64.1zm0 110c-25.3 0-45.9-20.5-45.9-45.9s20.5-45.9 45.9-45.9S174 166.7 174 192s-20.5 45.9-45.8 45.9z" />
                  <circle fill="#FFFFFF" cx="128.4" cy="191.9" r="31.9" />
                  <path fill="#FFFFFF"
                    d="M384.2 127.9c-35.4 0-64.1 28.7-64.1 64.1 0 35.4 28.7 64.1 64.1 64.1 35.4 0 64.1-28.7 64.1-64.1 0-35.4-28.7-64.1-64.1-64.1zm0 110c-25.3 0-45.9-20.5-45.9-45.9s20.5-45.9 45.9-45.9S430 166.7 430 192s-20.5 45.9-45.8 45.9z" />
                  <circle fill="#FFFFFF" cx="384.4" cy="191.9" r="31.9" />
                  <path fill="#FFFFFF"
                    d="M474.4 101.2l37.7-37.4h-76.4C392.9 29 321.8 0 255.9 0c-66 0-136.5 29-179.3 63.8H0l37.7 37.4C14.4 124.4 0 156.5 0 192c0 70.8 57.4 128.2 128.2 128.2 32.5 0 62.2-12.1 84.8-32.1l43.4 31.9 42.9-31.2-.5-1.2c22.7 20.2 52.5 32.5 85.3 32.5 70.8 0 128.2-57.4 128.2-128.2-.1-35.4-14.6-67.5-37.9-90.7zM368 64.8c-60.7 7.6-108.3 57.6-111.9 119.5-3.7-62-51.4-112.1-112.3-119.5 30.6-22 69.6-32.8 112.1-32.8S337.4 42.8 368 64.8zM128.2 288.2C75 288.2 32 245.1 32 192s43.1-96.2 96.2-96.2 96.2 43.1 96.2 96.2c-.1 53.1-43.1 96.2-96.2 96.2zm256 0c-53.1 0-96.2-43.1-96.2-96.2s43.1-96.2 96.2-96.2 96.2 43.1 96.2 96.2c-.1 53.1-43.1 96.2-96.2 96.2z" />
                </g>
              </svg>
            </div>
          </div>
          <div class="social-border"></div>
        </div>

        <nav class="footer-nav">
          <a href="#accueil" style="text-decoration: none" @click="navigateToSection('accueil')">Accueil</a>
          <router-link to="/carte" style="text-decoration: none">La Carte</router-link>
          <a href="#apropos" style="text-decoration: none" @click="navigateToSection('apropos')">À Propos</a>
          <a href="#avis" style="text-decoration: none" @click="navigateToSection('avis')">Avis</a>
          <router-link to="/contact" style="text-decoration: none">Contact</router-link>
        </nav>  
      </div>
    </footer>
    <div class="footer-end"></div>
</template>

<script>
export default {
  name: 'AppFooter',
  data(){
    return {
      horairesData: this.$store.state.horaires,
      contact:  JSON.parse(this.$store.state.contact.texte)
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
      openInstagram() {
      window.open('https://www.instagram.com/mia_grenoble/', '_blank')
    },
        openTripAdvisor() {
      window.open('https://www.tripadvisor.fr/Restaurant_Review-g187264-d28008936-Reviews-Mia-Grenoble_Isere_Auvergne_Rhone_Alpes.html', '_blank')
    },

    scrollToSection(sectionId) {
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    },
    navigateToSection(sectionId) {
      if (this.$route.path === "/") {
        this.scrollToSection(sectionId);
      } else {
        this.$router.push({ path: "/", hash: `#${sectionId}` });
        setTimeout(() => {
          this.scrollToSection(sectionId);
        }, 500);
      }
    },
    handleScroll() {
      this.isScrolled = window.scrollY > 50;
    }
  }
}
</script>
